import * as React from 'react';
import { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';
import {
  ArtTrack,
  Check,
  ArrowUpward,
  ToggleOffOutlined,
  ToggleOnOutlined,
  AttachMoney,
} from '@material-ui/icons';
import BulkAction from '../../bulk-action';
import { ART_TYPES, LICENSE_TYPES, PROD_STATUSES, PRICE_TIER } from '../../../constants';

const ProductsBulkActionButtons = (props) => (
  <Fragment>
    <BulkAction
      type="select"
      source="art_type_id"
      sourceName="Art Type"
      icon={<ArtTrack />}
      resource="products"
      resourceLabel="Artworks"
      options={ART_TYPES}
      {...props}
    />
    {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
      <>
        <BulkAction
          type="select"
          source="status"
          sourceName="Status"
          icon={<Check />}
          resource="products"
          resourceLabel="Artworks"
          options={PROD_STATUSES}
          {...props}
        />
        <BulkAction
          type="select"
          source="license_type"
          sourceName="License Type"
          icon={<ArrowUpward />}
          resource="products"
          resourceLabel="Artworks"
          options={LICENSE_TYPES}
          {...props}
        />
        <BulkAction
          type="select"
          source="price_tier"
          sourceName="Price Tier"
          icon={<AttachMoney />}
          resource="products"
          resourceLabel="Artworks"
          options={PRICE_TIER}
          {...props}
        />
        <BulkAction
          type="boolean"
          source="staff_pick"
          sourceName="Staff Pick Off"
          icon={<ToggleOffOutlined />}
          resource="products"
          resourceLabel="Artworks"
          booleanValue={0}
          {...props}
        />
        <BulkAction
          type="boolean"
          source="staff_pick"
          sourceName="Staff Pick On"
          icon={<ToggleOnOutlined />}
          resource="products"
          resourceLabel="Artworks"
          booleanValue={1}
          {...props}
        />
        <BulkAction
          type="boolean"
          source="wall"
          sourceName="Wall Off"
          icon={<ToggleOffOutlined />}
          resource="products"
          resourceLabel="Artworks"
          booleanValue={0}
          {...props}
        />
        <BulkAction
          type="boolean"
          source="wall"
          sourceName="Wall On"
          icon={<ToggleOnOutlined />}
          resource="products"
          resourceLabel="Artworks"
          booleanValue={1}
          {...props}
        />
      </>
    )}
    <BulkDeleteButton {...props} />
  </Fragment>
);

export default ProductsBulkActionButtons;
